module.exports = __webpack_public_path__ + "static/itesm-logo-e8c6c8bf832f834b848d090b5181b096.svg";